<template>
    <div>
        <noProcess></noProcess>
    </div>
</template>

<script>
    import common from '@/api/common';

    export default {
        mounted() {
            // this.getUserBoss();
            this.getLocation();
            this.getDeptPerson();
            this.getFaeDicInfo();
        },
        methods: {
            // 获取当前用户的领导id,存入缓存 Name
            getUserBoss() {
                let ADMIN = JSON.parse(localStorage.getItem('LS_ADMIN'))
                let user_id = ADMIN.USER_ID;
                let params = {
                    pkg: "crm_fae_public_pkg",
                    pro: "p_get_user_superior",
                    USER_ID: user_id.toString()
                }
                common.procedureQuery(params).then(res => {
                    if (res && res.flag) {
                        let formatData = [];
                        res.data.map(item => {
                            if (item.USER_DATA_ID) {
                                formatData.push(item.USER_DATA_ID)
                            }
                        });

                        localStorage.setItem('USER_BOSS', JSON.stringify(res.data));
                        localStorage.setItem('USER_BOSS_FORMAT', JSON.stringify(formatData));
                    }
                })
            },

            // 获取所有fae的办公地址
            getLocation() {
                let ADMIN = JSON.parse(localStorage.getItem('LS_ADMIN'))
                let user_id = ADMIN.USER_ID;
                let params = {
                    pkg: "crm_fae_public_pkg",
                    pro: "p_get_user_offiec_addr",
                }
                common.procedureQuery(params).then(res => {
                    if (res && res.flag) {
                        let formatData = [];
                        res.data.map(item => {
                            if (item.ACTUAL_LOCATION) {
                                formatData.push(item.ACTUAL_LOCATION)
                            }
                        });

                        localStorage.setItem('FAE_LOCATION', JSON.stringify(res.data));
                        localStorage.setItem('FAE_LOCATION_FORMAT', JSON.stringify(formatData));
                    }
                })
            },

            // 获取当前用户的下属id,存入缓存  ID
            getDeptPerson() {
                let ADMIN = JSON.parse(localStorage.getItem('LS_ADMIN'));
                let dept_id = ADMIN.USER_DEPARTMENT_ID;
                let user_id = ADMIN.USER_ID;
                let userLever = ADMIN.USER_LEVEL_NAME;
                if (userLever == 'M5' || userLever == 'M4') {
                    return
                }
                let params = {
                    pkg: "crm_fae_public_pkg",
                    pro: "p_get_user_junior",
                    USER_ID: user_id.toString()
                };

                common.procedureQuery(params).then(res => {
                    if (res && res.flag) {
                        let formatData = [];
                        res.data.map(item => {
                            if (item.ID) {
                                formatData.push(item.ID)
                            }
                        });
                        localStorage.setItem('USER_Subordinate', JSON.stringify(res.data));
                        localStorage.setItem('USER_Subordinate_FORMAT', JSON.stringify(formatData));
                    }
                })
            },

            // 获取FAE数据字典配置的数据
            getFaeDicInfo() {
                let fieldName = '';
                let moduleId = this.CoreNew.SYSTABLE.FAE;
                let systemId = '';
                common.findDicInfo(fieldName, moduleId, systemId).then(res => {
                    if (res && res.flag && res.data) {
                        let data = res.data;
                        let formatData = res.data.TEMP_CUSTOMER.map(item => {
                            return item.VALUE
                        });
                        localStorage.setItem('FIND_DIC_INFO_FAE', JSON.stringify(data));
                        localStorage.setItem('BOSS_NAME', JSON.stringify(formatData));
                    }
                })
            },

            // 得到当前FAE的领导id,存入缓存
            /* getFaeBoss(){
               let params = {
                 pkg: "crm_fae_public_pkg",
                 pro: "p_get_user_superior",
                 USER_ID: '777'
               };
               common.procedureQuery(params).then(res => {
                 if (res && res.flag) {
                   localStorage.setItem( `BOSS_FAE`, JSON.stringify(res.data));
                 }
               })
             },*/
        }
    }
</script>

<style scoped>

</style>